import { useQuery } from "react-query";
import { storeLocalData, getLocalData } from "../services/storage";
import useNetworkHealth from "./useNetworkHealth";
import openhouseAPI from "../services/openhouse";

export const useGetDashboardStats = (
  uuid: string | undefined,
  startDate: Date | null = null,
  endDate: Date | null = null
) => {
  const network = useNetworkHealth();
  const { isFetching, isFetched, data, error, refetch, isLoading } = useQuery(
    ["dashboardStats", uuid, startDate, endDate, network.status],
    async () => {
      if (!uuid || !startDate || !endDate) {
        return null;
      }
      if (network.isOffline) {
        const cachedData = await getLocalData("dashboardStats");
        if (cachedData) {
          return cachedData;
        }
      } else {
        try {
          const res = await openhouseAPI.post("/openhouse/stats", {
            hostUuid: uuid,
            startDate: startDate,
            endDate: endDate,
          });
          await storeLocalData("dashboardStats", res?.data?.data);
          return res?.data?.data;
        } catch (error) {
          console.error("Error fetching dashboard stats:", error);
          throw error;
        }
      }
    },
    {
      staleTime: 30000,
      cacheTime: 30000,
      enabled: !!uuid && !!startDate && !!endDate,
      retry: 1,
    }
  );

  const isWaitingForUuid = !uuid;

  return {
    isFetching: isWaitingForUuid ? true : isFetching,
    isFetched,
    data,
    error,
    refetch,
    isLoading: isWaitingForUuid ? true : isLoading,
  };
};
